import React, { PureComponent } from "react";
import { Button, Modal, ModalHeader, ModalBody, ModalFooter, ListGroup, ListGroupItem } from "reactstrap";
import classnames from "classnames";
import userService from "../services/userService";
import { getAPIURL, getServerRegions } from "../config";
import I18nProvider from "../services/I18nProvider";

class RegionSelector extends PureComponent {
  constructor(props) {
    super(props);
    // let regionUrl = StorageService.getFromLocalStorage(API_URL_KEY);
    let regionUrl = getAPIURL();
    this.state = {
      region:
        getServerRegions().length === 1 ? getServerRegions()[0].url : regionUrl,
      modalOpen: false,
    };
  }

  onUpdateRegion = (option) => {
    this.setState({ region: option.url, modalOpen: false });
    userService.setServerURL(option.url);
  };

  toggleModal = () => {
    this.setState({ modalOpen: !this.state.modalOpen }, () => {
      if (this.state.modalOpen) {
        setTimeout(() => {
          const selected = document.querySelector('.region-option[aria-selected="true"]');
          if (selected) selected.focus();
        }, 100);
      }
    });
  };

  getSelectedRegion = () => {
    return getServerRegions().find(region => region.url === this.state.region);
  };

  componentDidMount() {
    userService.setServerURL(this.state.region);
  }

  render() {
    let { loading, error, style } = this.props;
    const { modalOpen } = this.state;
    const selectedRegion = this.getSelectedRegion();

    return getServerRegions().length > 1 ? (
      <>
        <Button
          color="light"
          onClick={this.toggleModal}
          disabled={loading}
          className={classnames(
            "region-selector-button",
            error ? "border-danger" : "",
            this.props.className || ""
          )}
          style={{
            borderRadius: "12px",
            border: error ? "2px solid #e74c3c" : "2px solid #e8ecf0",
            padding: "0.75rem 1rem",
            fontSize: "0.95rem",
            fontWeight: 600,
            minWidth: "200px",
            backgroundColor: "#fff",
            color: "#2c3e50",
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
            transition: "all 0.2s ease-in-out",
            boxShadow: "0 2px 8px rgba(0, 0, 0, 0.06)",
            ...style
          }}
        >
          <span>
            <i className="fas fa-globe mr-2" style={{ color: "#4e8cff" }} />
            {selectedRegion ? selectedRegion.region : "Select Region"}
          </span>
          <i className="fas fa-chevron-down ml-2" style={{ color: "#7a869a" }} />
        </Button>

        <Modal 
          isOpen={modalOpen} 
          toggle={this.toggleModal}
          centered
          size="sm"
          className="region-selector-modal"
        >
          <ModalHeader 
            toggle={this.toggleModal}
            style={{
              borderBottom: "1px solid #e8ecf0",
              padding: "1.5rem",
              backgroundColor: "#f8fafc"
            }}
          >
            <div style={{ display: "flex", alignItems: "center" }}>
              <i className="fas fa-globe mr-3" style={{ color: "#4e8cff", fontSize: "1.2rem" }} />
              <span style={{ fontSize: "1.1rem", fontWeight: 600, color: "#2c3e50" }}>
                Select Region
              </span>
            </div>
          </ModalHeader>
          
          <ModalBody style={{ padding: 0 }}>
            <ListGroup flush role="listbox" aria-label="Select Region">
              {getServerRegions().map((region, index) => (
                <ListGroupItem
                  key={region.url}
                  tag="button"
                  action
                  onClick={() => this.onUpdateRegion(region)}
                  onKeyDown={(e) => {
                    if (e.key === "ArrowDown") {
                      e.preventDefault();
                      const next = e.currentTarget.nextElementSibling;
                      if (next) next.focus();
                    } else if (e.key === "ArrowUp") {
                      e.preventDefault();
                      const prev = e.currentTarget.previousElementSibling;
                      if (prev) prev.focus();
                    }
                  }}
                  role="option"
                  aria-selected={region.url === this.state.region}
                  style={{
                    padding: "1rem 1.5rem",
                    cursor: "pointer",
                    border: "none",
                    borderBottom: index < getServerRegions().length - 1 ? "1px solid #f1f3f4" : "none",
                    backgroundColor: region.url === this.state.region ? "#f8fafc" : "transparent",
                    transition: "all 0.15s ease-in-out",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "space-between",
                    textAlign: "left",
                    width: "100%"
                  }}
                  className="region-option"
                >
                  <div style={{ display: "flex", alignItems: "center" }}>
                    <div
                      style={{
                        width: "12px",
                        height: "12px",
                        borderRadius: "50%",
                        backgroundColor: region.url === this.state.region ? "#4e8cff" : "#e8ecf0",
                        marginRight: "1rem",
                        transition: "all 0.15s ease-in-out"
                      }}
                    />
                    <span
                      style={{
                        fontSize: "0.95rem",
                        fontWeight: region.url === this.state.region ? 600 : 500,
                        color: "#2c3e50"
                      }}
                    >
                      {region.region}
                    </span>
                  </div>
                  {region.url === this.state.region && (
                    <i className="fas fa-check" style={{ color: "#4e8cff", fontSize: "0.9rem" }} />
                  )}
                </ListGroupItem>
              ))}
            </ListGroup>
          </ModalBody>
        </Modal>

        <style>{`
          .region-selector-button:hover {
            border-color: #4e8cff !important;
            box-shadow: 0 4px 16px rgba(0, 0, 0, 0.1) !important;
            transform: translateY(-1px);
          }
          
          .region-option:hover {
            background-color: #f8fafc !important;
          }
          
          .region-selector-modal .modal-content {
            border-radius: 16px;
            box-shadow: 0 20px 60px rgba(0, 0, 0, 0.15);
            border: none;
          }
          
          .region-selector-modal .modal-header .close {
            font-size: 1.5rem;
            color: #7a869a;
            opacity: 1;
            transition: all 0.15s ease-in-out;
          }
          
          .region-selector-modal .modal-header .close:hover {
            color: #4e8cff;
            transform: scale(1.1);
          }
        `}</style>
      </>
    ) : null;
  }
}

export default RegionSelector;
